import request from '@/utils/requests.js'

// Exam Types API Services
export const examTypeService = {
  // Exam Type Management
  async createExamType(examTypeData) {
    return request({
      url: '/exam-types/',
      method: 'post',
      data: examTypeData
    })
  },

  async listExamTypes(params = {}) {
    return request({
      url: '/exam-types/',
      method: 'get',
      params
    })
  },

  async getExamTypeById(examTypeId) {
    return request({
      url: `/exam-types/${examTypeId}`,
      method: 'get'
    })
  },

  async getExamTypeByCode(code) {
    return request({
      url: `/exam-types/code/${code}`,
      method: 'get'
    })
  },

  async updateExamType(examTypeId, examTypeData) {
    return request({
      url: `/exam-types/${examTypeId}`,
      method: 'put',
      data: examTypeData
    })
  },

  async deleteExamType(examTypeId) {
    return request({
      url: `/exam-types/${examTypeId}`,
      method: 'delete'
    })
  },

  async searchExamTypes(searchTerm, filters = {}) {
    const params = { search: searchTerm, ...filters };
    return request({
      url: '/exam-types/',
      method: 'get',
      params
    })
  },

  async getExamTypesByCategory(category, activeOnly = true) {
    return request({
      url: '/exam-types/',
      method: 'get',
      params: { category, active_only: activeOnly }
    })
  },

  async getCategories() {
    return request({
      url: '/exam-types/categories/list',
      method: 'get'
    })
  },

  async getStatistics() {
    return request({
      url: '/exam-types/statistics/summary',
      method: 'get'
    })
  }
}
